const data = [
    {
        id: 1,
        image: "./assets/project-1.jpg",
        desc:"description"
    },
    {
        id: 2,
        image: "./assets/project-2.jpg",
        desc:"description"
    },
    {
        id: 3,
        image: "./assets/project-3.jpg",
        desc:"description"
    },
    {
        id: 4,
        image: "./assets/project-4.jpg",
        desc:"description"
    },
    {
        id: 5,
        image: "./assets/project-5.jpg",
        desc:"description"
    },
    {
        id: 6,
        image: "./assets/project-6.jpg",
        desc:"description"
    }
]
export default data;